<div class="schedule-navbar">
    <div>
        <button (click)="prev()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-left"></mat-icon>
        </button>
    </div>
    <div class="content">
        <p class="large">{{ date | date: 'd MMM' }}</p>
        <p class="small">{{ date | date: 'EEEE' }}</p>
    </div>
    <div>
        <button (click)="next()" mat-icon-button color="white">
            <mat-icon fontSet="far" fontIcon="fa-chevron-right"></mat-icon>
        </button>
    </div>
</div>
<div class="below-navbar container-fluid">
    <h2>Asfalt {{ projectId }} - {{ date | date: 'EEE dd MMMM yyyy' }}</h2>
    <div class="d-flex flex-wrap flex-md-nowrap">
        @if (projectId) {
            <button
                class="mb-2 me-2"
                [disabled]="loadingAsfalt"
                (click)="copyAsphalt()"
                color="primary"
                mat-raised-button>
                {{ loadingAsfalt ? 'Laden...' : 'Overnemen planning' }}
            </button>
        }
        <div class="flex-fill"></div>
        @if (project && otherProjectsThisDay?.length) {
            <button class="me-2 mb-2" (click)="otherProjectThisDay()" mat-raised-button color="accent">
                Andere projecten
            </button>
        }
    </div>
    <app-asphalt-used-list #asphaltUsedList [project]="project" [date]="date" [print]="print"></app-asphalt-used-list>

    <div [class.d-none]="!(asphaltUsedList?.projectUsedAsphaltList?.length > 0)">
        <h2>
            Leveranties
            <button (click)="calculateAdhesives()" color="primary" mat-raised-button>Bereken kleeflagen</button>
        </h2>
        <app-asphalt-used-list
            #asphaltAdhesiveList
            [project]="project"
            [date]="date"
            [isAdhesive]="true"
            [print]="print"></app-asphalt-used-list>
    </div>

    @if (project) {
        <h2>Opmerkingen {{ projectId }} - {{ date | date: 'EEE dd MMMM yyyy' }}</h2>
        @if (form) {
            <div class="tiny-content">
                <simple-tiny class="w-100 mb-3" [showMenuBar]="false" [content]="form.controls.comment" height="600">
                </simple-tiny>
                <div class="history">
                    @if (projectComments?.length === 0) {
                        <h1 class="pb-3">Er zijn deze week nog geen andere dagrapporten ingevoerd</h1>
                    }
                    @if (projectComments?.length > 0) {
                        <h1>Andere toelichtingen deze week:</h1>
                    }
                    @for (comment of projectComments; track comment) {
                        <div class="item">
                            <h1 class="mb-0">
                                {{ comment.date | date: 'EEEE d MMMM yyyy' }}
                            </h1>
                            <div class="mb-3">
                                <small>{{ comment?.user?.name ?? 'Opmerkingen' }}</small>
                            </div>
                            <div [innerHTML]="comment.comment"></div>
                        </div>
                    }
                </div>
            </div>
        }
    }
</div>

<div class="button-wrapper">
    <div class="container">
        <div class="buttons">
            <button
                class="planning-button"
                mat-raised-button
                color="accent"
                routerLink="/project-rapport/{{ projectId ?? 'null' }}/{{ date | date: 'w' }}/{{
                    date | date: 'yyyy'
                }}">
                Weekrapport
            </button>
            <div class="settings-menu">
                <app-settings-menu [projectId]="project?.afas_project_id" [date]="date"></app-settings-menu>
            </div>
            <button
                class="planning-button"
                [disabled]="form?.invalid || saving"
                (click)="save()"
                mat-raised-button
                color="primary">
                {{ saving ? 'Aan het opslaan...' : saved ? 'Wijzigingen opgeslagen' : 'Opslaan' }}
            </button>
        </div>
    </div>
</div>

<ng-template #chooseProjectDialog>
    <div class="dialog-container">
        <h2 class="condensed dialog-title" mat-dialog-title>Kies een project</h2>
        <div class="dialog-content" mat-dialog-content>
            @if (notOwnProject) {
                <div>Kies een project waarvoor je op deze dag {{ environment.executorName }} bent</div>
            }
            <div class="projects-dialog pt-2 pb-2">
                @for (project of projectDialogProjects; track project) {
                    <div (click)="projectDialog.close(project.afas_project_id)">
                        <b>{{ project.afas_project_id }}</b> {{ project.name }}
                    </div>
                }
                <div (click)="projectDialog.close(projectId)">
                    Huidige project <b>{{ projectId }}</b>
                </div>
            </div>
        </div>
    </div>
</ng-template>
